export default {
    data(){
        return {
            isLoading           : false,
            isScrolling         : false,
            RecordLimit         : Number(window.chaton_scripts_vars.showRec),
            userId              : window.chaton_scripts_vars.userId,
            errors              : '',
            TRANS               : window.chaton_scripts_vars.chatSetting.translations,
        }
    },
};